import CloseIconSvg from '@web/assets/svg/Icons/32/close-gray.svg';
import { ClickableHeaderButton } from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalHeader/timesheetViewModalHeader.styles';

type Props = {
  onClick: () => void;
};
const CloseHeaderButton = ({ onClick }: Props) => (
  <ClickableHeaderButton onClick={onClick}>
    <CloseIconSvg />
  </ClickableHeaderButton>
);

export default CloseHeaderButton;
